<!-- 器械基础资料 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <purchaseOrderAction1 v-if="showStatus" ref="purchaseOrderAction1" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></purchaseOrderAction1>
        </el-drawer>
        <div class="page_content_top">
            <v-button :btnFlag="false" :buttonFlag="false">
                <template slot="button">
                    <div>
                        <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
                            刷新
                        </el-button>
                    </div>
                </template>
            </v-button>
            <div class="page_content_top_line">
                <v-search  :searchList="formList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table ref="myTable" stripe :data="returnData.list" :height="tableHeight/1.6 " :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini" @row-click="mainRowClick">
                <!-- <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column> -->
                <el-table-column align="center" v-for="(tableValye, tableKey) in tableList" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                            {{ scope.row.isWms == 0 ? '否' : '是' }}
                        </el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                        <span v-else-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="packList" :height="tableHeight/3 " :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">

                <el-table-column align="center" v-for="(tableValye, tableKey) in packTableList" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                            {{ scope.row.isWms == 0 ? '否' : '是' }}
                        </el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                        <span v-else-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
import tableList from "./basicinstrumentList.js";
import purchaseOrderAction1 from "@/components/purchaseOrderAction1.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        purchaseOrderAction1
    },
    data() {
        //这里存放数据
        return {
            tableList: tableList,
            tableHeight: 0,
            getRequestData: {

                page: 1,
                rows: 30,
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
                searchValue: "",
                // fileState:"",
                // fileType:"",
                // downState:""
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            selectedDetailsDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            parentSearchData: {},
            sField: "",
            requesUrl: "",
            ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
            showStatus: false,
            actionData: {},
            multipleSelection: [],
            formList: [
                {
                    entityField: "start",
                    fieldType: "date",
                    formatterContent: null,
                    isRequired: 0,
                    isShow: 1,
                    searchId: null,
                    extractId: null,
                    setField: null,
                    showField: "开始时间",
                },
                {
                    entityField: "end",
                    fieldType: "date",
                    formatterContent: null,
                    isRequired: 0,
                    isShow: 1,
                    searchId: null,
                    extractId: null,
                    setField: null,
                    showField: "结束时间",
                },
                {
                    entityField: "searchValue",
                    fieldType: "string",
                    formatterContent: null,
                    isRequired: 0,
                    isShow: 1,
                    searchId: null,
                    extractId: null,
                    setField: null,
                    showField: "检索条件",
                },


            ],
            packTableList: [
                {
                    entityField: "bzcpbs",
                    showField: "包装产品标识",
                    fieldWeight: 120,
                    fieldType: "string",
                    fixed: 'left',
                },
                {
                    entityField: "bznhxyjbzcpbs",
                    showField: "包装内含下一级包装产品标识",
                    fieldWeight: 120,
                    fieldType: "string",
                    fixed: 'left',
                },
                {
                    entityField: "bznhxyjcpbssl",
                    showField: "包装内含下一级产品标识数量",
                    fieldWeight: 120,
                    fieldType: "string",
                    fixed: 'left',
                },
                {
                    entityField: "cpbzjb",
                    showField: "包装级别",
                    fieldWeight: 120,
                    fieldType: "string",
                    fixed: 'left',
                },
            ],
            packList: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {

        // selectedDataIndex: {
        //     handler: function (newValue, oldValue) {
        //         this.selectedDetailsDataIndex = 0;
        //     },
        //     deep: true,
        // },
    },
    //方法集合
    methods: {
        async getPackDetail(row) {
            if (this.returnData.list.length == 0) return this.$message.warning("暂无数据！")
            let ids = []
            if (row) {
                ids = [row.devicerecordKey]
            } else {
                ids = [this.returnData.list[this.selectedDataIndex].devicerecordKey]
            }
            let res = await this.$http.basicinstrumentGetPack({ ids: ids })
            if (res.status == 200) {
                // this.$message.success(res.message)
                this.packList = res.result
            }
        },
        mainRowClick(row, column, event) {
            // this.selectedDataIndex = column
            this.getPackDetail(row)
        },
        async downFile(row) {
            window.location.href = this.requesUrl + '/udiTrace/downUdiFile?fileId=' + row.fileId
            setTimeout(() => {
                this.searchData()
            }, 500)
        },
        isRowSelectable(row, index) {
            if (row.failReason != '' && row.failReason != null && row.failReason != undefined) {
                return row.disabled;
            } else {
                return !row.disabled;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false;
            if (e == 1) this.getDataList();
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            console.log(orderId)
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },


        selectedDetailsDataAction(data) {
            var info = data.split(",").map(Number);
            this.selectedDataIndex = info[0];
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData);
            switch (actionData.actionType) {
                case 1:
                    this.confirmUpdate();
                    break;
                case 4://导出
                    this.exportFun()
                    break;




            }
        },
        async confirmUpdate() {
            if (this.multipleSelection.length == 0) {
                this.$message.warning("暂无数据")
                return
            }
            let res = await this.$http.udiTraceUpdStocksend(this.multipleSelection)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.getDataList()
            }
        },

        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },


        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.basicinstrumentQuery(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                console.log("this.returnData.list", this.returnData.list);
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
                this.$nextTick(() => {
                    // 模拟点击第一行
                    const firstRow = this.$refs.myTable.$el.querySelector('.el-table__body-wrapper tr:first-child');
                    if (firstRow) {
                        const clickEvent = new MouseEvent('click', {
                            view: window,
                            bubbles: true,
                            cancelable: false
                        });
                        firstRow.dispatchEvent(clickEvent);
                    }
                });
                this.getPackDetail()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr;
            } catch (ex) {
                return str;
            }
        },

        // 获取按钮权限
        async getButtonList() {
            // this.buttonList = await this.$common.getActionButton()
            // 
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.getPageInfo();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {


    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>